import { IStoryContent, IUser } from '../types';

export const processStoryContentOrTemplateContent = data => {
  return {
    _id: data._id,
    createdAt: data.createdAt,
    createdBy: data.createdBy || data.authorId,
    entity_id: data.entityId,
    content: data.content,
    contentHtml: data.contentHtml,
    title: data.title,
    layout: data.layout,
    group: data.group,
    format: data.format,
    type: data.type,
    order: data.order,
    active: data.active,
    story: data.storyId || data.storyTemplateId,
    updatedAt: data.updatedAt,
    updatedBy: data.updatedBy,
    description: data.description,
    shouldClear: data.shouldClear,
    shouldUpdate: data.shouldUpdate,
    scrollTo: data.scrollTo,
    mediaIndex: data.mediaIndex,
    contentChartConfig: data.contentChartConfig,
    author: data.author
      ? ({
        _id: data.author._id,
        email: data.author.email,
        name: { first: data.author.firstName, last: data.author.lastName },
        og_id: data.author.opengovId
      } as IUser)
      : {}
  } as IStoryContent;
};
